export const DataConsts = {
    defaultProfileImageURL: 'https://swilab.com/images/defaultProfileImg.png', 
}
